module.exports = __webpack_public_path__ + "img/free-3.cbad2e3f.png";